import { call, put, select, fork, all } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';
import keyBy from 'lodash.keyby';

import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';
import { ERROR_MODAL_QUERY_STRING_PARAM } from 'components/ErrorModal/constants';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { takeLatestWithCancel } from 'utils/redux-saga';

import { RequestedLoadDocumentsAction } from './types';
import {
    succeededLoadDocuments,
    failedLoadDocuments,
    setDocuments
} from './actions';
import { DOCUMENTS_LOAD_REQUESTED, DOCUMENTS_LOAD_CANCELED } from './constants';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* loadDocuments(
    action: RequestedLoadDocumentsAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const url = `${REACT_APP_API_URL}/v1/Documents`;

    // Select organization ID
    const organizationId = yield select(selectCurrentOrganizationId);

    try {
        const response = yield call(axios, url, {
            method: 'get',
            headers: {
                Authorization: idToken
            },
            params: {
                organizationId,
                filter: {
                    eager: '[documentAttributes, activities, harvestInspections, harvestTimesheet]',
                    require: {
                        documentSetId: action.data.documentSetId
                    },
                    where: {
                        'documentAttributes.deletedAt': { $exists: false },
                        'activities.deletedAt': { $exists: false }
                    }
                }
            }
        });

        yield all([
            put(succeededLoadDocuments(response)),
            put(setDocuments(keyBy(response.data, 'uuid')))
        ]);
    } catch (error) {
        yield all([
            put(failedLoadDocuments(error)),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: 'DOCUMENT_LOAD'
                })
            )
        ]);
    }
}

export function* watchDocumentsLoadRequested(): SagaIterator {
    yield takeLatestWithCancel(
        DOCUMENTS_LOAD_REQUESTED,
        DOCUMENTS_LOAD_CANCELED,
        loadDocuments
    );
}

export default function* documentsSagas(): SagaIterator {
    yield fork(watchDocumentsLoadRequested);
}
